import { useEffect, useState } from "react"
import UserCoupon from "../../models/UserCoupon.model"
import { UserApi } from "../../api/User.api";
import Error from "../../models/Error.model";
import { ERROR_TYPE, PAYMENT_STATUS, Products } from "../../commons/Const";
import UserSubscription from "../../models/UserSubscription.model";
import PaymentHistory from "../../models/PaymentHistory.model";
import moment from "moment";
import { setSignOut, setUser } from "../../store/modules/app";
import { useAppDispatch, useAppSelector } from "../../store";
import { Storage } from "../../utils/Storage";
import { useNavigate } from "react-router-dom";


export default function MeViewModel() {

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const user = useAppSelector(state => state.app.user)

  const [coupon, setCoupon] = useState<UserCoupon|null>(null);
  const [couponCode, setCouponCode] = useState('');

  const [subscription, setSubscription] = useState<UserSubscription>()
  const [paymentHistoryList, setPaymentHistoryList] = useState<PaymentHistory[]>([]);
  const [latestPaymentHistory, setLatestPaymentHistory] = useState<PaymentHistory>()

  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [nextDate, setNextDate] = useState('')
  const [nextAmount, setNextAmount] = useState(0);

  const [enableChangeSubscription, setEnableChangeSubscription] = useState(false);

  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false)
  const [showWithdrawal, setShowWithdrawal] = useState(false)
  const [showChangeSubscription, setShowChangeSubscription] = useState(false)
  const [showSubscriptionCancel, setShowSubscriptionCancel] = useState(false)

  const [showLoading, setShowLoading] = useState(false);

  const [failReason, setFailReason] = useState<string|null>(null);

  useEffect(() => {
    getUser();
    getCoupon();
    getSubscription();
  }, [])

  useEffect(() => {
    if(user === undefined) return;

    if(user === null) navigate('/');
  }, [user])

  useEffect(() => {
    if(subscription === undefined) return

    const paymentHistoryList = subscription.paymentHistoryList.filter(v => v.status !== PAYMENT_STATUS.PENDING);
    if(paymentHistoryList.length !== 0) {
      setLatestPaymentHistory(paymentHistoryList[0]);

      if(paymentHistoryList[0].status === PAYMENT_STATUS.FAILED) {
        const failData = JSON.parse(paymentHistoryList[0].failData ?? '');
  
        setFailReason(failData.fail_reason ?? null);
      }
    }

    

    const sMoment = moment(subscription.createdAt);

    if(process.env.REACT_APP_MODE === 'production') {

      sMoment.set({hours: 0, minutes: 0, seconds: 0, milliseconds: 0});
      
      setStartDate(sMoment.format('YYYY.MM.DD HH:mm'));
      setEndDate(sMoment.clone().add(subscription.round, 'months').add(-1, 'days').format('YYYY.MM.DD 23:59'));
      setNextDate(sMoment.clone().add(subscription.round, 'months').format('YYYY.MM.DD'));
      
      
    }
    else {
      sMoment.set({seconds: 0, milliseconds: 0});

      setStartDate(sMoment.format('YYYY.MM.DD HH:mm'));
      setEndDate(sMoment.clone().add(subscription.round * 10, 'minutes').add(-1, 'minutes').format('YYYY.MM.DD HH:mm'))
      setNextDate(sMoment.clone().add(subscription.round * 10, 'minutes').format('YYYY.MM.DD HH:mm'));
      
    }

    const results = subscription.paymentHistoryList;

    setPaymentHistoryList(results);

    if(results.length !== 0) {
      const latestPaymentHistory = results[0];
      //setLatestPaymentHistory(latestPaymentHistory);
      if(latestPaymentHistory.status !== PAYMENT_STATUS.FAILED) {
        setEnableChangeSubscription(latestPaymentHistory.type === 0);
      }

      const pendingPaymentHistory = results.find(v => v.status === PAYMENT_STATUS.PENDING);
      if(pendingPaymentHistory !== undefined) {
        setNextAmount(pendingPaymentHistory.amount);
      }
    }

  }, [subscription])

  const getUser = () => {
    UserApi.getMe()
    .then(result => {
      dispatch(setUser(result))
    }).catch(console.error)
  }

  const getSubscription = () => {
    UserApi.getSubscription()
    .then(result => {
      setSubscription(result)
      //getPaymentHistory(result.id)
    }).catch(error => {
      setSubscription(undefined)
    })
  }

  const cancelSubscription = () => {
    setShowLoading(true)
    UserApi.cancelSubscription()
    .then(result => {
      setShowSubscriptionCancel(false);
      setEnableChangeSubscription(false);
      setNextAmount(0);
      getSubscription();
      getUser();
    }).catch(error => {
      console.log(error)
    }).finally(() => {
      setShowLoading(false)
    })
  }

  // const getPaymentHistory = (userSubscriptionId: number) => {
  //   UserApi.getPaymentHistoryList({
  //     userSubscriptionId
  //   })
  //   .then(results => {

  //     setPaymentHistoryList(results);

  //     if(results.length !== 0) {
  //       const latestPaymentHistory = results[0];
  //       setLatestPaymentHistory(latestPaymentHistory);
  //       if(latestPaymentHistory.status !== PAYMENT_STATUS.FAILED) {
  //         setEnableChangeSubscription(latestPaymentHistory.type === 0);
  //       }

  //       const pendingPaymentHistory = results.find(v => v.status === PAYMENT_STATUS.PENDING);
  //       if(pendingPaymentHistory !== undefined) {
  //         setNextAmount(pendingPaymentHistory.amount);
  //       }
  //     }

  //     //setSubscription(result)
  //   }).catch(error => {
  //     //setSubscription(undefined)
  //   })
  // }

  const getCoupon = async () => {
    try {
      
      const couponList = await UserApi.getCouponList();

      
      if(couponList.length !== 0) {
        setCoupon(couponList[0])
      }

    } catch (error) {
      console.error(error)
    }
  }

  const registerCoupon = async () => {

    if(couponCode === '') return alert('쿠폰번호를 입력해주세요.');
    try {
      await UserApi.registerCoupon(couponCode);

      alert('등록되었습니다.');

      getCoupon();
      setCouponCode('');
    } catch (error) {
      if(error instanceof Error) {
        if(error.code === ERROR_TYPE.NOT_EXIST_COUPON) {
          alert('유효하지 않은 쿠폰번호입니다.')
        }
        else if(error.code === ERROR_TYPE.ALREADY_REGISTER_COUPON) {
          alert('사용되었거나 만료된 쿠폰번호입니다.')
        }
      }
    }
  }

  const changePaymentInfo = async () => {

    if(user === undefined || user === null) return;

    try {
      let paymentData = {
        pg: process.env.REACT_APP_PG_CARD,
        pay_method : 'card',
        merchant_uid : `${user.phone}-${new Date().getTime()}`,
        name : '결제정보변경',
        buyer_name : user.name,
        buyer_tel : user.phone,
        customer_uid: `sellerguard-stage-${user.phone}`,
      }

      setShowLoading(true);

      const paymentResult = await requestPayment(paymentData);

      await UserApi.modifyPaymentInfo(paymentResult.customer_uid);

      getSubscription();

      alert('결제정보가 변경되었습니다.');
      
    } catch (error) {
      console.error(error)
      if(error instanceof Error) {
        if(error.code === ERROR_TYPE.FAIL_PAYMENT) {
          alert(`결제 실패\n사유 : ${error.message}`)
        }
      }
    } finally {
      setShowLoading(false);
    }
  }

  const changeSubscription = async () => {
    try {
      setShowLoading(true);
      await UserApi.changeSubscriptionAmount(Products[2].id);
      alert('월 자문료가 변경되었습니다.');
      setShowChangeSubscription(false);
      getSubscription();  
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoading(false);
    }
  }

  const requestPayment = async (data: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      const { IMP } = window
      IMP.init("imp84428497");

      IMP.request_pay(data, (response: any) => {
        if(response.success) {
          resolve(response);
        }
        else {
          reject(response);
        }
      });
    })
  }

  const rePayment = async () => {
    try {

      setShowLoading(true);
      await UserApi.rePayment();

      getSubscription();
      setFailReason(null);

    } catch (error) {
      console.error(error)
      if(error instanceof Error) {
        if(error.code === ERROR_TYPE.FAIL_PAYMENT) {
          alert(error.message)
        }
      }
    } finally {
      setShowLoading(false);
    }
  }

  const withdrawal = () => {
    UserApi.withdrawal()
    .then(result => {
      Storage.remove('token');
      dispatch(setSignOut())
    }).catch(error => {
      if(error instanceof Error) {
        if(error.code === 8) {
          alert('구독중으로 탈퇴가 불가능합니다.');
        }
      }
    })
  }

  return {
    user,
    subscription, setSubscription,
    startDate, setStartDate, endDate, setEndDate, nextDate, nextAmount,
    enableChangeSubscription, setEnableChangeSubscription,
    showResetPasswordModal, setShowResetPasswordModal,
    showWithdrawal, setShowWithdrawal,
    showChangeSubscription, setShowChangeSubscription,
    failReason, setFailReason,
    paymentHistoryList, setPaymentHistoryList,
    latestPaymentHistory, setLatestPaymentHistory,
    showSubscriptionCancel, cancelSubscription,
    changePaymentInfo, 
    setShowSubscriptionCancel,
    coupon, registerCoupon, couponCode, setCouponCode,
    changeSubscription,
    rePayment,
    withdrawal,
    showLoading,
  }
}